import React, { PureComponent } from 'react';

import classNames from 'classnames/bind';
import style from './Slider.scss';
const ctx = classNames.bind(style);

import ArticleSpreader from '../../components/ArticleSpreader';

import ReactTouchEvents from 'react-touch-events';

const INCREMENT = 1;
const DECREMENT = -1;

const SWIPE_DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right',
};

class Slider extends PureComponent {
  static propTypes = {
    // renderSlide: PropTypes.func,
    // slides: PropTypes.array,
  };
  static defaultProps = {
    slides: [],
  };

  state = {
    currentIdx: 0,
  };

  handleSlide = idx => {
    this.setState({
      currentIdx: idx,
    });
  };

  renderNavigationControls() {
    const { slides } = this.props;

    const { currentIdx } = this.state;

    const disableLeft = this.getNextIdxActive(DECREMENT) === currentIdx;
    const disableRight = this.getNextIdxActive(INCREMENT) === currentIdx;

    return (
      <div className={ctx('nav')}>
        <span
          className={ctx('nav-item', 'nav-item--left', {
            'nav-item--active': !disableLeft,
          })}
          onClick={this.handleSwipe.bind(null, SWIPE_DIRECTIONS.RIGHT)}
        >
          <img src={'images/arrowIcon.svg'} className={ctx('row-item-svg')} />
        </span>
        <span className={ctx('nav-title')}>{slides[currentIdx].title}</span>
        <span
          className={ctx('nav-item', 'nav-item--right', {
            'nav-item--active': !disableRight,
          })}
          onClick={this.handleSwipe.bind(null, SWIPE_DIRECTIONS.LEFT)}
        >
          <img src={'images/arrowIcon.svg'} className={ctx('row-item-svg')} />
        </span>
      </div>
    );
  }

  renderRow() {
    const { slides } = this.props;

    const slidesCount = slides.length;

    const slideWidthPrecentage = 100 / slidesCount;

    const { currentIdx } = this.state;

    return (
      <div
        className={ctx('row')}
        style={{
          width: `${100 * slidesCount}%`,
          transform: `translateX(-${slideWidthPrecentage * currentIdx}%)`,
        }}
      >
        {slides.map((slide, idx) => (
          <div
            className={ctx('row-item')}
            style={{
              width: `${slideWidthPrecentage}%`,
            }}
            key={idx}
          >
            <img src={slide.image} width="100%" className={ctx('image')} />
            <div className={ctx('description')}>{slide.description}</div>
          </div>
        ))}
      </div>
    );
  }

  getNextIdxActive(add) {
    const { currentIdx: active } = this.state;

    const max = this.props.slides.length - 1;
    const min = 0;

    const nextIdx = active + add;

    if (nextIdx < min) {
      return min;
    } else if (nextIdx > max) {
      return max;
    }

    return nextIdx;
  }

  handleTap = () => {
    this.handleSlide(this.getNextIdxActive(INCREMENT));
  };

  handleSwipe = direction => {
    switch (direction) {
      case SWIPE_DIRECTIONS.LEFT:
        {
          this.handleSlide(this.getNextIdxActive(INCREMENT));
        }
        break;
      case SWIPE_DIRECTIONS.RIGHT:
        {
          this.handleSlide(this.getNextIdxActive(DECREMENT));
        }
        break;
    }
  };

  render() {
    const { title } = this.props;

    return (
      <div className={ctx('inner')}>
        <ArticleSpreader>
          <div className={ctx('title')}>{title}</div>
          <div className={ctx('Slider')}>
            <div className={ctx('wrap')}>
              {this.renderNavigationControls()}
              <ReactTouchEvents
                onTap={this.handleTap}
                onSwipe={this.handleSwipe}
              >
                {this.renderRow()}
              </ReactTouchEvents>
            </div>
          </div>
        </ArticleSpreader>
      </div>
    );
  }
}

export default Slider;
